import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=1ef88f3d&scoped=true"
import script from "./BlogArticle.js?vue&type=script&lang=js&external"
export * from "./BlogArticle.js?vue&type=script&lang=js&external"
import style0 from "./BlogArticle.scss?vue&type=style&index=0&id=1ef88f3d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef88f3d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,NewsletterBanner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NewsletterBanner/NewsletterBanner.vue').default,LatestArticles: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/articles/LatestArticles/LatestArticles.vue').default,RelatedLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/RelatedLinks/RelatedLinks.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
